import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface ScrapeAthleticNetRequest {
    url: string;
    individual_uuid: string;
}

interface ScrapeAthleticNetResponse {
    success: boolean;
    message: string;
    job_id: string;
    status: string;
    results?: {
        event_count: number;
        new_count: number;
        duplicate_count: number;
        athlete_name: string;
    };
    error?: string;
}

type ReturnType = Promise<AxiosResponse<ScrapeAthleticNetResponse>>;

const scrapeAthleticNetProfile = (data: ScrapeAthleticNetRequest): ReturnType => {
    return Request.post('/workouts/track-events/scrape-athletic-net', data);
};

export default scrapeAthleticNetProfile;
